import { graphqlApolloClient } from "../graphql-apollo-client"
import { GET_PROJECT_BENEFICIARIES_WITH_ACTIVITIES } from "./graphql/queries/get-project-beneficiaries-with-activities"

export const getProjectBeneficiariesWithActivities = async ({ submissionId }) => {
  const { data } = await graphqlApolloClient.query({
    query: GET_PROJECT_BENEFICIARIES_WITH_ACTIVITIES,
    fetchPolicy: "network-only",
    variables: {
      submissionId
    }
  })

  return data?.ProjectBeneficiariesWithActivities
  || []
}